<template>
  <window-container class="require-print-window">
    <div class="card">
      <div class="no-print" style="text-align:right;padding-top:10px;padding-right:10px;">
        <el-button type="primary" icon="el-icon-printer" @click="print">Print</el-button>
        <el-button type="success" icon="el-icon-message" @click="email">Email</el-button>
      </div>
      <div>
        <div style="font-size:28px;font-weight:bold;text-align:center;">
          Cystron Technology Limited
        </div>
        <div style="text-align:center;padding:10px;">
          10/F Kras Asia Industrial Building 79 Hung To Road, Kwun Tong, Kowloon, Hong Kong<br/>
          Web:&nbsp;www.cystrontech.com&nbsp;&nbsp;Email:&nbsp;Enquiry@cystrontech.com
        </div>
        <div style="font-size:22px;font-weight:bold;text-align:center;padding:10px;">
          Requirement
        </div>
      </div>
      <div>
        <div style="text-align:right;padding-right:10px;">
          {{ operTime | engDate }}
        </div>
        <cate-table
          :columns="columns"
          :data="list"
          :loading="loading"
          style="margin:10px 0;"
          ref="cateTable">
        </cate-table>
      </div>
    </div>
  </window-container>
</template>

<script>
import qs from 'qs'
export default {
  data () {
    return {
      list: [],
      total: 0,
      loading: false,
      showDescription: false,
      operTime: ''
    }
  },
  computed: {
    columns () {
      if (this.showDescription) {
        return [
          { key: 'part_no', title: 'Part Number' },
          { key: 'description', title: 'Description' },
          { key: 'brand', title: 'Brand' },
          { key: 'display_qty', title: 'Qty' },
          { key: 'display_price', title: 'Price' },
          { key: 'remark', title: 'Remark' }
        ]
      } else {
        return [
          { key: 'part_no', title: 'Part Number' },
          { key: 'description', title: 'Description' },
          { key: 'brand', title: 'Brand' },
          { key: 'display_qty', title: 'Qty' },
          { key: 'display_price', title: 'Price' },
          { key: 'remark', title: 'Remark' }
        ]
      }
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.loading = true
      this.$http.get('/dbapi/list_params?id=' + this.$route.params.id).then(data => {
        if (data.list.length === 0) {
          return Promise.reject()
        } else {
          this.showDescription = data.list[0].show_description === '1'
          this.operTime = data.list[0].oper_time
          let params = JSON.parse(data.list[0].params)
          params.start = 0
          params.limit = 100
          return this.$http.get('/dbapi/requirement_list', {
            params,
            paramsSerializer: function(params) {
              return qs.stringify(params, { arrayFormat: 'repeat' })
            }
          })
        }
      }).then(data => {
        this.loading = false
        this.list = data.list
        this.total = data.total
      }).catch(() => this.loading = false)
    },
    print () {
      window.print()
    },
    formatList (data) {
      if (!data || data.length === 0) {
        return []
      }
      let category_name = ''
      let class_name = ''
      let list = data.concat()
      for (let i = 0; i < list.length; i++) {
        if (list[i].category_name != category_name) {
          list.splice(i, 0, {
            category_name: list[i].category_name,
            is_category: true
          })
          category_name = list[i].category_name
          if (++i >= list.length) {
            break;
          }
        }
        if (list[i].class_name != class_name) {
          list.splice(i, 0, {
            class_name: list[i].class_name,
            is_class: true
          })
          class_name = list[i].class_name
          i++
        }
      }
      return list
    },
    email () {
      let win = this.$open('/loading', 1050)
      this.$http.post('/api/mail-create', {
        template: 'requirement',
        subject: 'requirement',
        columns: this.columns,
        list: this.formatList(this.list)
      }).then(result => {
          win.location = '/email/' + result.insertId
      })
    }
  }
}
</script>

